import { Input } from '@/components/ui/input';
import { useControlContext } from '@/contexts/ControlContext';
import { cn } from '@/lib/utils';

import Checkbox from '../ui/checkbox';

const UnitCheckGroup = ({ className, disabled, name }) => {
  const { form, setFormByKey } = useControlContext();

  const data = form[name] || {};

  const resetAllChecks = (value) => {
    setFormByKey(name, {
      ...data,
      ...(value && {
        mgt: false,
        qa: false,
        ow: false,
        th: false,
      }),
      all: value,
    });
  };

  const handleChecked = (key, value) => {
    setFormByKey(name, { ...data, [key]: value });
  };

  return (
    <div className={cn('grid grid-cols-3 gap-2', className)}>
      <Checkbox
        disabled={disabled || data.all}
        label="MGT"
        onChange={(value) => handleChecked('mgt', value)}
        value={data.mgt}
      />
      <Checkbox
        disabled={disabled || data.all}
        label="QA/QC"
        onChange={(value) => handleChecked('qa', value)}
        value={data.qa}
      />
      <Checkbox
        disabled={disabled || data.all}
        label="O&W"
        onChange={(value) => handleChecked('ow', value)}
        value={data.ow}
      />
      <Checkbox
        disabled={disabled || data.all}
        label="T&H"
        onChange={(value) => handleChecked('th', value)}
        value={data.th}
      />
      <Checkbox
        disabled={disabled}
        label="All Employees"
        onChange={resetAllChecks}
        value={data.all}
      />
      <div className="flex gap-2">
        <Checkbox disabled={disabled} label="Others:" />
        <Input
          className="h-6 pl-1"
          disabled={disabled}
          onChange={(value) => handleChecked('others', value)}
          value={data.others}
        />
      </div>
    </div>
  );
};

export default UnitCheckGroup;
